import type { ReactNode } from 'react';

type PaymentReceiptShellProps = {
  children: ReactNode;
};

/**
 * Moldura da página pública do segurado: fundo neutro claro e um cartão branco
 * central com o logo. Feita para o celular, que é onde o segurado paga.
 * O `body` não rola (`main.css`): a moldura tem a altura da tela e rola por
 * dentro, como o layout do login.
 */
export function PaymentReceiptShell({ children }: PaymentReceiptShellProps) {
  return (
    <div className='h-dvh overflow-y-auto bg-alba-white-500 px-4 py-6 font-[family-name:Montserrat,sans-serif] sm:py-12'>
      <main className='mx-auto flex w-full max-w-[520px] flex-col gap-6 rounded-3xl border border-alba-gray-200 bg-alba-white-400 px-5 py-7 sm:px-10 sm:py-10'>
        <img
          src='/Logo Alba Fundo Branco-01.svg'
          alt='Alba Seguradora'
          className='mx-auto h-16 w-auto sm:h-20'
        />
        {children}
      </main>
    </div>
  );
}
